"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderDetails = void 0;
const Base_1 = require("./Base");
exports.GetOrderDetails = {
    url: Base_1.URL_BASE + "/GetOrderDetails",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetOrderDetails.js.map